import { configureStore } from '@reduxjs/toolkit'
import apiReducer from './slices/apiSlice.ts'
import phasedayReducer from './slices/phasedaySlice.ts'
import horoscopeReducer from './slices/horoscopeSlice.ts'
import fetchCompatibilityReducer from './slices/CompatibilitySlice.ts'

export const store = configureStore({
  reducer: {
    api: apiReducer,
    phaseday: phasedayReducer,
    horoscope: horoscopeReducer,
    compatibility: fetchCompatibilityReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
